import { render, staticRenderFns } from "./SelectPCD.vue?vue&type=template&id=2f790743&scoped=true"
import script from "./SelectPCD.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectPCD.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f790743",
  null
  
)

export default component.exports